// Решения response-интерсептора о повторе запроса — вынесены сюда, чтобы их
// можно было прогнать.
//
// Обе ветки подставляют в повтор наш заголовок: рекавери после 403 кладёт свежий
// client_token, ретрай после 401 — JWT из localStorage. Пока они жили инлайном в
// main.js, единственной их защитой был греп по файлу — а греп ловит только ту
// форму записи, которую в него заложили: точечное присваивание
// (`error.config.headers.Authorization = …`) вместо скобочного он пропускает,
// декоративный вызов предиката в соседней строке восстанавливает счёт, а
// безобидный рефакторинг (`var cfg = error.config`) даёт ложный красный.
// Проверено мутациями в ревью — все четыре случая инвариант-счётчик не удержал.

import { shouldRefreshClientToken } from "@/utils/antiScrapeRetry";
import { isUnauthenticatedRequest, isIntentionalLogout } from "@/utils/sessionExpiry";

// Рекавери client_token после 403.
//
// Чужой 403 к нашему анти-скрейпингу отношения не имеет: рекавери сходило бы за
// свежим client_token на наш app_version и подставило бы его в повтор запроса к
// чужому хосту — то есть выдало бы третьей стороне действующий токен вместо
// того, чтобы починить свой.
export function shouldRecoverClientToken(error, isOurApi) {
  if (!shouldRefreshClientToken(error)) return false;
  return isOurApi(error.config);
}

// Ретрай с токеном из localStorage после 401.
//
// Первый 401 после refresh обычно означает, что запрос ушёл БЕЗ токена
// (axios.defaults.Authorization не восстановлен после гидрации), а не что токен
// невалиден — поэтому один раз повторяем с токеном из localStorage.
//
// На чужой 401 (Green-API отвечает им на неверный instance/token) подстановка
// означала бы отправку действующего JWT третьей стороне уже явным присваиванием,
// мимо предиката request-интерсептора.
// FT-136 добавил сюда два условия. Раньше их держал маршрутный guard в main.js
// (`router.currentRoute.path != "/signin"` и соседи), снятый REQ-09: без них 401 на
// неверный пароль повторял бы POST users/sign_in вторым запросом, а намеренный выход
// уходил бы на сервер дважды.
export function shouldRetryWithStoredToken(error, storedToken, isOurApi) {
  if (!storedToken || storedToken === "null") return false;
  if (!error || !error.config) return false;
  if (error.config._authRetried) return false;
  if (isIntentionalLogout(error)) return false;
  if (isUnauthenticatedRequest(error.config)) return false;
  return isOurApi(error.config);
}
